import { render, staticRenderFns } from "./mg-popup.vue?vue&type=template&id=1942445e&"
import script from "./mg-popup.vue?vue&type=script&lang=js&"
export * from "./mg-popup.vue?vue&type=script&lang=js&"
import style0 from "./mg-popup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports